import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Authentication } from '../../providers/authentication';

/*
  Generated class for the Debug page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-debug',
  templateUrl: 'debug.html'
})
export class DebugPage {
  debugInfo = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private authService: Authentication) {}

  ionViewDidLoad() {
    // console.log('ionViewDidLoad DebugPage');
    // this.updateDebugInfo();
  }

  ionViewDidEnter() {
    // console.log('ionViewDidEnter DebugPage');
    this.updateDebugInfo();
  }

  updateDebugInfo() {
    this.debugInfo = {
      auth: {
        // isAuthenticated: null,
        token: this.authService.getToken(),
      }
    };
    // this.authService.isAuthenticated().subscribe(result => this.debugInfo['auth'].isAuthenticated = result);
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.updateDebugInfo();

    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 100);
  }

  public logout() {
    this.authService.logout();
    this.updateDebugInfo();
  }

}



// WEBPACK FOOTER //
// ./src/pages/debug/debug.ts